import { IDropdownStyles, IStyle } from '@fluentui/react';
import { IInfoStyles } from '@h2oai/ui-kit';

export interface ITimeFilterStyles {
  filterContainer?: IStyle;
  dropdownContainer?: IStyle;
  labelContainer?: IStyle;
}

export const timeFilterStylesDefault = (): Partial<ITimeFilterStyles> => ({
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0.25rem',
    gap: '0.5rem',
  },
  dropdownContainer: {
    display: 'flex',
    gridGap: '1rem',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

export const envDropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: '20%',
    marginTop: '8px',
  },
  dropdown: {
    width: '100%',
  },
};

export const timeFrameDropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: '12rem',
  },
  dropdown: {
    width: '100%',
  },
  dropdownItem: {
    padding: '10px 20px',
  },
};

export const infoStyles: Partial<IInfoStyles> = {
  root: {
    cursor: 'default',
  },
};

export const datePickerStyles = {
  root: {
    height: '2rem',
    width: '12rem',
  },
};
